function cov_1f7x4xylj() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/Login.tsx";
    var hash = "9462266b7964add98df36af5c827270dc54171d0";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/Login.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 32,
                    column: 20
                },
                end: {
                    line: 32,
                    column: 49
                }
            },
            "1": {
                start: {
                    line: 33,
                    column: 25
                },
                end: {
                    line: 33,
                    column: 53
                }
            },
            "2": {
                start: {
                    line: 35,
                    column: 24
                },
                end: {
                    line: 35,
                    column: 81
                }
            },
            "3": {
                start: {
                    line: 37,
                    column: 23
                },
                end: {
                    line: 37,
                    column: 74
                }
            },
            "4": {
                start: {
                    line: 39,
                    column: 39
                },
                end: {
                    line: 47,
                    column: 1
                }
            },
            "5": {
                start: {
                    line: 49,
                    column: 24
                },
                end: {
                    line: 459,
                    column: 1
                }
            },
            "6": {
                start: {
                    line: 50,
                    column: 15
                },
                end: {
                    line: 50,
                    column: 50
                }
            },
            "7": {
                start: {
                    line: 51,
                    column: 18
                },
                end: {
                    line: 51,
                    column: 31
                }
            },
            "8": {
                start: {
                    line: 52,
                    column: 18
                },
                end: {
                    line: 52,
                    column: 31
                }
            },
            "9": {
                start: {
                    line: 53,
                    column: 18
                },
                end: {
                    line: 53,
                    column: 31
                }
            },
            "10": {
                start: {
                    line: 55,
                    column: 13
                },
                end: {
                    line: 55,
                    column: 34
                }
            },
            "11": {
                start: {
                    line: 57,
                    column: 17
                },
                end: {
                    line: 62,
                    column: 3
                }
            },
            "12": {
                start: {
                    line: 64,
                    column: 29
                },
                end: {
                    line: 69,
                    column: 2
                }
            },
            "13": {
                start: {
                    line: 65,
                    column: 19
                },
                end: {
                    line: 65,
                    column: 27
                }
            },
            "14": {
                start: {
                    line: 66,
                    column: 21
                },
                end: {
                    line: 66,
                    column: 58
                }
            },
            "15": {
                start: {
                    line: 68,
                    column: 2
                },
                end: {
                    line: 68,
                    column: 40
                }
            },
            "16": {
                start: {
                    line: 71,
                    column: 37
                },
                end: {
                    line: 74,
                    column: 3
                }
            },
            "17": {
                start: {
                    line: 81,
                    column: 5
                },
                end: {
                    line: 81,
                    column: 40
                }
            },
            "18": {
                start: {
                    line: 82,
                    column: 47
                },
                end: {
                    line: 84,
                    column: 2
                }
            },
            "19": {
                start: {
                    line: 85,
                    column: 42
                },
                end: {
                    line: 87,
                    column: 2
                }
            },
            "20": {
                start: {
                    line: 89,
                    column: 43
                },
                end: {
                    line: 92,
                    column: 2
                }
            },
            "21": {
                start: {
                    line: 93,
                    column: 39
                },
                end: {
                    line: 96,
                    column: 2
                }
            },
            "22": {
                start: {
                    line: 97,
                    column: 44
                },
                end: {
                    line: 100,
                    column: 2
                }
            },
            "23": {
                start: {
                    line: 101,
                    column: 28
                },
                end: {
                    line: 101,
                    column: 68
                }
            },
            "24": {
                start: {
                    line: 102,
                    column: 31
                },
                end: {
                    line: 102,
                    column: 74
                }
            },
            "25": {
                start: {
                    line: 104,
                    column: 25
                },
                end: {
                    line: 162,
                    column: 2
                }
            },
            "26": {
                start: {
                    line: 106,
                    column: 3
                },
                end: {
                    line: 106,
                    column: 13
                }
            },
            "27": {
                start: {
                    line: 107,
                    column: 23
                },
                end: {
                    line: 107,
                    column: 43
                }
            },
            "28": {
                start: {
                    line: 109,
                    column: 2
                },
                end: {
                    line: 111,
                    column: 3
                }
            },
            "29": {
                start: {
                    line: 110,
                    column: 3
                },
                end: {
                    line: 110,
                    column: 24
                }
            },
            "30": {
                start: {
                    line: 113,
                    column: 2
                },
                end: {
                    line: 121,
                    column: 3
                }
            },
            "31": {
                start: {
                    line: 119,
                    column: 3
                },
                end: {
                    line: 119,
                    column: 32
                }
            },
            "32": {
                start: {
                    line: 120,
                    column: 3
                },
                end: {
                    line: 120,
                    column: 40
                }
            },
            "33": {
                start: {
                    line: 123,
                    column: 2
                },
                end: {
                    line: 156,
                    column: 3
                }
            },
            "34": {
                start: {
                    line: 124,
                    column: 3
                },
                end: {
                    line: 124,
                    column: 32
                }
            },
            "35": {
                start: {
                    line: 126,
                    column: 3
                },
                end: {
                    line: 129,
                    column: 6
                }
            },
            "36": {
                start: {
                    line: 131,
                    column: 3
                },
                end: {
                    line: 151,
                    column: 5
                }
            },
            "37": {
                start: {
                    line: 138,
                    column: 5
                },
                end: {
                    line: 141,
                    column: 8
                }
            },
            "38": {
                start: {
                    line: 143,
                    column: 5
                },
                end: {
                    line: 149,
                    column: 6
                }
            },
            "39": {
                start: {
                    line: 144,
                    column: 30
                },
                end: {
                    line: 144,
                    column: 33
                }
            },
            "40": {
                start: {
                    line: 146,
                    column: 6
                },
                end: {
                    line: 146,
                    column: 53
                }
            },
            "41": {
                start: {
                    line: 148,
                    column: 6
                },
                end: {
                    line: 148,
                    column: 44
                }
            },
            "42": {
                start: {
                    line: 153,
                    column: 3
                },
                end: {
                    line: 153,
                    column: 10
                }
            },
            "43": {
                start: {
                    line: 154,
                    column: 9
                },
                end: {
                    line: 156,
                    column: 3
                }
            },
            "44": {
                start: {
                    line: 155,
                    column: 3
                },
                end: {
                    line: 155,
                    column: 67
                }
            },
            "45": {
                start: {
                    line: 158,
                    column: 2
                },
                end: {
                    line: 161,
                    column: 5
                }
            },
            "46": {
                start: {
                    line: 164,
                    column: 27
                },
                end: {
                    line: 171,
                    column: 2
                }
            },
            "47": {
                start: {
                    line: 167,
                    column: 2
                },
                end: {
                    line: 170,
                    column: 5
                }
            },
            "48": {
                start: {
                    line: 173,
                    column: 23
                },
                end: {
                    line: 177,
                    column: 2
                }
            },
            "49": {
                start: {
                    line: 174,
                    column: 2
                },
                end: {
                    line: 176,
                    column: 3
                }
            },
            "50": {
                start: {
                    line: 175,
                    column: 3
                },
                end: {
                    line: 175,
                    column: 21
                }
            },
            "51": {
                start: {
                    line: 179,
                    column: 30
                },
                end: {
                    line: 186,
                    column: 2
                }
            },
            "52": {
                start: {
                    line: 182,
                    column: 2
                },
                end: {
                    line: 185,
                    column: 5
                }
            },
            "53": {
                start: {
                    line: 188,
                    column: 35
                },
                end: {
                    line: 208,
                    column: 2
                }
            },
            "54": {
                start: {
                    line: 189,
                    column: 2
                },
                end: {
                    line: 207,
                    column: 3
                }
            },
            "55": {
                start: {
                    line: 190,
                    column: 3
                },
                end: {
                    line: 193,
                    column: 5
                }
            },
            "56": {
                start: {
                    line: 196,
                    column: 4
                },
                end: {
                    line: 196,
                    column: 23
                }
            },
            "57": {
                start: {
                    line: 198,
                    column: 3
                },
                end: {
                    line: 204,
                    column: 6
                }
            },
            "58": {
                start: {
                    line: 205,
                    column: 3
                },
                end: {
                    line: 205,
                    column: 27
                }
            },
            "59": {
                start: {
                    line: 206,
                    column: 3
                },
                end: {
                    line: 206,
                    column: 24
                }
            },
            "60": {
                start: {
                    line: 210,
                    column: 28
                },
                end: {
                    line: 218,
                    column: 2
                }
            },
            "61": {
                start: {
                    line: 211,
                    column: 2
                },
                end: {
                    line: 211,
                    column: 23
                }
            },
            "62": {
                start: {
                    line: 212,
                    column: 2
                },
                end: {
                    line: 217,
                    column: 5
                }
            },
            "63": {
                start: {
                    line: 220,
                    column: 20
                },
                end: {
                    line: 222,
                    column: 2
                }
            },
            "64": {
                start: {
                    line: 221,
                    column: 2
                },
                end: {
                    line: 221,
                    column: 35
                }
            },
            "65": {
                start: {
                    line: 224,
                    column: 34
                },
                end: {
                    line: 231,
                    column: 2
                }
            },
            "66": {
                start: {
                    line: 225,
                    column: 27
                },
                end: {
                    line: 225,
                    column: 37
                }
            },
            "67": {
                start: {
                    line: 227,
                    column: 2
                },
                end: {
                    line: 230,
                    column: 5
                }
            },
            "68": {
                start: {
                    line: 233,
                    column: 1
                },
                end: {
                    line: 258,
                    column: 8
                }
            },
            "69": {
                start: {
                    line: 234,
                    column: 19
                },
                end: {
                    line: 234,
                    column: 27
                }
            },
            "70": {
                start: {
                    line: 235,
                    column: 17
                },
                end: {
                    line: 235,
                    column: 38
                }
            },
            "71": {
                start: {
                    line: 237,
                    column: 2
                },
                end: {
                    line: 253,
                    column: 3
                }
            },
            "72": {
                start: {
                    line: 239,
                    column: 3
                },
                end: {
                    line: 252,
                    column: 6
                }
            },
            "73": {
                start: {
                    line: 240,
                    column: 4
                },
                end: {
                    line: 251,
                    column: 5
                }
            },
            "74": {
                start: {
                    line: 241,
                    column: 34
                },
                end: {
                    line: 241,
                    column: 37
                }
            },
            "75": {
                start: {
                    line: 243,
                    column: 5
                },
                end: {
                    line: 243,
                    column: 57
                }
            },
            "76": {
                start: {
                    line: 244,
                    column: 11
                },
                end: {
                    line: 251,
                    column: 5
                }
            },
            "77": {
                start: {
                    line: 245,
                    column: 5
                },
                end: {
                    line: 247,
                    column: 7
                }
            },
            "78": {
                start: {
                    line: 248,
                    column: 5
                },
                end: {
                    line: 248,
                    column: 19
                }
            },
            "79": {
                start: {
                    line: 250,
                    column: 5
                },
                end: {
                    line: 250,
                    column: 43
                }
            },
            "80": {
                start: {
                    line: 255,
                    column: 2
                },
                end: {
                    line: 257,
                    column: 4
                }
            },
            "81": {
                start: {
                    line: 256,
                    column: 3
                },
                end: {
                    line: 256,
                    column: 16
                }
            },
            "82": {
                start: {
                    line: 260,
                    column: 1
                },
                end: {
                    line: 288,
                    column: 48
                }
            },
            "83": {
                start: {
                    line: 261,
                    column: 20
                },
                end: {
                    line: 261,
                    column: 30
                }
            },
            "84": {
                start: {
                    line: 263,
                    column: 2
                },
                end: {
                    line: 287,
                    column: 3
                }
            },
            "85": {
                start: {
                    line: 268,
                    column: 3
                },
                end: {
                    line: 286,
                    column: 4
                }
            },
            "86": {
                start: {
                    line: 272,
                    column: 4
                },
                end: {
                    line: 275,
                    column: 7
                }
            },
            "87": {
                start: {
                    line: 277,
                    column: 4
                },
                end: {
                    line: 280,
                    column: 7
                }
            },
            "88": {
                start: {
                    line: 282,
                    column: 4
                },
                end: {
                    line: 285,
                    column: 7
                }
            },
            "89": {
                start: {
                    line: 290,
                    column: 1
                },
                end: {
                    line: 299,
                    column: 37
                }
            },
            "90": {
                start: {
                    line: 292,
                    column: 2
                },
                end: {
                    line: 298,
                    column: 3
                }
            },
            "91": {
                start: {
                    line: 296,
                    column: 3
                },
                end: {
                    line: 296,
                    column: 27
                }
            },
            "92": {
                start: {
                    line: 297,
                    column: 3
                },
                end: {
                    line: 297,
                    column: 24
                }
            },
            "93": {
                start: {
                    line: 301,
                    column: 25
                },
                end: {
                    line: 342,
                    column: 2
                }
            },
            "94": {
                start: {
                    line: 303,
                    column: 3
                },
                end: {
                    line: 303,
                    column: 13
                }
            },
            "95": {
                start: {
                    line: 305,
                    column: 2
                },
                end: {
                    line: 307,
                    column: 3
                }
            },
            "96": {
                start: {
                    line: 306,
                    column: 3
                },
                end: {
                    line: 306,
                    column: 50
                }
            },
            "97": {
                start: {
                    line: 309,
                    column: 2
                },
                end: {
                    line: 341,
                    column: 4
                }
            },
            "98": {
                start: {
                    line: 344,
                    column: 26
                },
                end: {
                    line: 381,
                    column: 2
                }
            },
            "99": {
                start: {
                    line: 345,
                    column: 49
                },
                end: {
                    line: 345,
                    column: 59
                }
            },
            "100": {
                start: {
                    line: 346,
                    column: 25
                },
                end: {
                    line: 348,
                    column: 4
                }
            },
            "101": {
                start: {
                    line: 350,
                    column: 2
                },
                end: {
                    line: 367,
                    column: 3
                }
            },
            "102": {
                start: {
                    line: 351,
                    column: 3
                },
                end: {
                    line: 366,
                    column: 5
                }
            },
            "103": {
                start: {
                    line: 369,
                    column: 2
                },
                end: {
                    line: 380,
                    column: 4
                }
            },
            "104": {
                start: {
                    line: 383,
                    column: 22
                },
                end: {
                    line: 403,
                    column: 2
                }
            },
            "105": {
                start: {
                    line: 384,
                    column: 27
                },
                end: {
                    line: 384,
                    column: 37
                }
            },
            "106": {
                start: {
                    line: 386,
                    column: 2
                },
                end: {
                    line: 400,
                    column: 3
                }
            },
            "107": {
                start: {
                    line: 387,
                    column: 3
                },
                end: {
                    line: 399,
                    column: 5
                }
            },
            "108": {
                start: {
                    line: 402,
                    column: 2
                },
                end: {
                    line: 402,
                    column: 14
                }
            },
            "109": {
                start: {
                    line: 405,
                    column: 29
                },
                end: {
                    line: 444,
                    column: 2
                }
            },
            "110": {
                start: {
                    line: 406,
                    column: 52
                },
                end: {
                    line: 406,
                    column: 62
                }
            },
            "111": {
                start: {
                    line: 408,
                    column: 2
                },
                end: {
                    line: 441,
                    column: 3
                }
            },
            "112": {
                start: {
                    line: 409,
                    column: 29
                },
                end: {
                    line: 411,
                    column: 5
                }
            },
            "113": {
                start: {
                    line: 412,
                    column: 21
                },
                end: {
                    line: 414,
                    column: 24
                }
            },
            "114": {
                start: {
                    line: 415,
                    column: 21
                },
                end: {
                    line: 415,
                    column: 55
                }
            },
            "115": {
                start: {
                    line: 417,
                    column: 3
                },
                end: {
                    line: 440,
                    column: 5
                }
            },
            "116": {
                start: {
                    line: 443,
                    column: 2
                },
                end: {
                    line: 443,
                    column: 14
                }
            },
            "117": {
                start: {
                    line: 446,
                    column: 1
                },
                end: {
                    line: 458,
                    column: 3
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 49,
                        column: 24
                    },
                    end: {
                        line: 49,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 49,
                        column: 43
                    },
                    end: {
                        line: 459,
                        column: 1
                    }
                },
                line: 49
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 64,
                        column: 29
                    },
                    end: {
                        line: 64,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 43
                    },
                    end: {
                        line: 69,
                        column: 2
                    }
                },
                line: 64
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 104,
                        column: 25
                    },
                    end: {
                        line: 104,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 104,
                        column: 37
                    },
                    end: {
                        line: 162,
                        column: 2
                    }
                },
                line: 104
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 137,
                        column: 4
                    },
                    end: {
                        line: 137,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 137,
                        column: 25
                    },
                    end: {
                        line: 150,
                        column: 5
                    }
                },
                line: 137
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 164,
                        column: 27
                    },
                    end: {
                        line: 164,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 166,
                        column: 12
                    },
                    end: {
                        line: 171,
                        column: 2
                    }
                },
                line: 166
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 173,
                        column: 23
                    },
                    end: {
                        line: 173,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 173,
                        column: 61
                    },
                    end: {
                        line: 177,
                        column: 2
                    }
                },
                line: 173
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 179,
                        column: 30
                    },
                    end: {
                        line: 179,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 181,
                        column: 12
                    },
                    end: {
                        line: 186,
                        column: 2
                    }
                },
                line: 181
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 188,
                        column: 35
                    },
                    end: {
                        line: 188,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 188,
                        column: 66
                    },
                    end: {
                        line: 208,
                        column: 2
                    }
                },
                line: 188
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 210,
                        column: 28
                    },
                    end: {
                        line: 210,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 210,
                        column: 40
                    },
                    end: {
                        line: 218,
                        column: 2
                    }
                },
                line: 210
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 220,
                        column: 20
                    },
                    end: {
                        line: 220,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 220,
                        column: 32
                    },
                    end: {
                        line: 222,
                        column: 2
                    }
                },
                line: 220
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 224,
                        column: 34
                    },
                    end: {
                        line: 224,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 224,
                        column: 46
                    },
                    end: {
                        line: 231,
                        column: 2
                    }
                },
                line: 224
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 233,
                        column: 17
                    },
                    end: {
                        line: 233,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 233,
                        column: 23
                    },
                    end: {
                        line: 258,
                        column: 2
                    }
                },
                line: 233
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 239,
                        column: 21
                    },
                    end: {
                        line: 239,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 239,
                        column: 42
                    },
                    end: {
                        line: 252,
                        column: 4
                    }
                },
                line: 239
            },
            "13": {
                name: "cleanUp",
                decl: {
                    start: {
                        line: 255,
                        column: 18
                    },
                    end: {
                        line: 255,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 255,
                        column: 28
                    },
                    end: {
                        line: 257,
                        column: 3
                    }
                },
                line: 255
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 260,
                        column: 17
                    },
                    end: {
                        line: 260,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 260,
                        column: 23
                    },
                    end: {
                        line: 288,
                        column: 2
                    }
                },
                line: 260
            },
            "15": {
                name: "(anonymous_15)",
                decl: {
                    start: {
                        line: 290,
                        column: 17
                    },
                    end: {
                        line: 290,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 290,
                        column: 23
                    },
                    end: {
                        line: 299,
                        column: 2
                    }
                },
                line: 290
            },
            "16": {
                name: "(anonymous_16)",
                decl: {
                    start: {
                        line: 301,
                        column: 25
                    },
                    end: {
                        line: 301,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 301,
                        column: 44
                    },
                    end: {
                        line: 342,
                        column: 2
                    }
                },
                line: 301
            },
            "17": {
                name: "(anonymous_17)",
                decl: {
                    start: {
                        line: 344,
                        column: 26
                    },
                    end: {
                        line: 344,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 344,
                        column: 45
                    },
                    end: {
                        line: 381,
                        column: 2
                    }
                },
                line: 344
            },
            "18": {
                name: "(anonymous_18)",
                decl: {
                    start: {
                        line: 383,
                        column: 22
                    },
                    end: {
                        line: 383,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 383,
                        column: 48
                    },
                    end: {
                        line: 403,
                        column: 2
                    }
                },
                line: 383
            },
            "19": {
                name: "(anonymous_19)",
                decl: {
                    start: {
                        line: 405,
                        column: 29
                    },
                    end: {
                        line: 405,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 405,
                        column: 55
                    },
                    end: {
                        line: 444,
                        column: 2
                    }
                },
                line: 405
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 109,
                        column: 2
                    },
                    end: {
                        line: 111,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 109,
                            column: 2
                        },
                        end: {
                            line: 111,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 109
            },
            "1": {
                loc: {
                    start: {
                        line: 113,
                        column: 2
                    },
                    end: {
                        line: 121,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 113,
                            column: 2
                        },
                        end: {
                            line: 121,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 113
            },
            "2": {
                loc: {
                    start: {
                        line: 114,
                        column: 3
                    },
                    end: {
                        line: 117,
                        column: 28
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 114,
                            column: 3
                        },
                        end: {
                            line: 114,
                            column: 15
                        }
                    }, {
                        start: {
                            line: 115,
                            column: 3
                        },
                        end: {
                            line: 115,
                            column: 17
                        }
                    }, {
                        start: {
                            line: 116,
                            column: 3
                        },
                        end: {
                            line: 116,
                            column: 28
                        }
                    }, {
                        start: {
                            line: 117,
                            column: 3
                        },
                        end: {
                            line: 117,
                            column: 28
                        }
                    }],
                line: 114
            },
            "3": {
                loc: {
                    start: {
                        line: 123,
                        column: 2
                    },
                    end: {
                        line: 156,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 123,
                            column: 2
                        },
                        end: {
                            line: 156,
                            column: 3
                        }
                    }, {
                        start: {
                            line: 154,
                            column: 9
                        },
                        end: {
                            line: 156,
                            column: 3
                        }
                    }],
                line: 123
            },
            "4": {
                loc: {
                    start: {
                        line: 123,
                        column: 6
                    },
                    end: {
                        line: 123,
                        column: 31
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 123,
                            column: 6
                        },
                        end: {
                            line: 123,
                            column: 19
                        }
                    }, {
                        start: {
                            line: 123,
                            column: 23
                        },
                        end: {
                            line: 123,
                            column: 31
                        }
                    }],
                line: 123
            },
            "5": {
                loc: {
                    start: {
                        line: 143,
                        column: 5
                    },
                    end: {
                        line: 149,
                        column: 6
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 143,
                            column: 5
                        },
                        end: {
                            line: 149,
                            column: 6
                        }
                    }, {
                        start: {
                            line: 147,
                            column: 12
                        },
                        end: {
                            line: 149,
                            column: 6
                        }
                    }],
                line: 143
            },
            "6": {
                loc: {
                    start: {
                        line: 154,
                        column: 9
                    },
                    end: {
                        line: 156,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 154,
                            column: 9
                        },
                        end: {
                            line: 156,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 154
            },
            "7": {
                loc: {
                    start: {
                        line: 154,
                        column: 13
                    },
                    end: {
                        line: 154,
                        column: 39
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 154,
                            column: 13
                        },
                        end: {
                            line: 154,
                            column: 26
                        }
                    }, {
                        start: {
                            line: 154,
                            column: 30
                        },
                        end: {
                            line: 154,
                            column: 39
                        }
                    }],
                line: 154
            },
            "8": {
                loc: {
                    start: {
                        line: 174,
                        column: 2
                    },
                    end: {
                        line: 176,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 174,
                            column: 2
                        },
                        end: {
                            line: 176,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 174
            },
            "9": {
                loc: {
                    start: {
                        line: 189,
                        column: 2
                    },
                    end: {
                        line: 207,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 189,
                            column: 2
                        },
                        end: {
                            line: 207,
                            column: 3
                        }
                    }, {
                        start: {
                            line: 194,
                            column: 9
                        },
                        end: {
                            line: 207,
                            column: 3
                        }
                    }],
                line: 189
            },
            "10": {
                loc: {
                    start: {
                        line: 237,
                        column: 2
                    },
                    end: {
                        line: 253,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 237,
                            column: 2
                        },
                        end: {
                            line: 253,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 237
            },
            "11": {
                loc: {
                    start: {
                        line: 240,
                        column: 4
                    },
                    end: {
                        line: 251,
                        column: 5
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 240,
                            column: 4
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }, {
                        start: {
                            line: 244,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }],
                line: 240
            },
            "12": {
                loc: {
                    start: {
                        line: 244,
                        column: 11
                    },
                    end: {
                        line: 251,
                        column: 5
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 244,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }, {
                        start: {
                            line: 249,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }],
                line: 244
            },
            "13": {
                loc: {
                    start: {
                        line: 263,
                        column: 2
                    },
                    end: {
                        line: 287,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 263,
                            column: 2
                        },
                        end: {
                            line: 287,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 263
            },
            "14": {
                loc: {
                    start: {
                        line: 264,
                        column: 3
                    },
                    end: {
                        line: 266,
                        column: 28
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 264,
                            column: 3
                        },
                        end: {
                            line: 264,
                            column: 17
                        }
                    }, {
                        start: {
                            line: 265,
                            column: 3
                        },
                        end: {
                            line: 265,
                            column: 35
                        }
                    }, {
                        start: {
                            line: 266,
                            column: 3
                        },
                        end: {
                            line: 266,
                            column: 28
                        }
                    }],
                line: 264
            },
            "15": {
                loc: {
                    start: {
                        line: 268,
                        column: 3
                    },
                    end: {
                        line: 286,
                        column: 4
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 268,
                            column: 3
                        },
                        end: {
                            line: 286,
                            column: 4
                        }
                    }, {
                        start: {
                            line: 276,
                            column: 10
                        },
                        end: {
                            line: 286,
                            column: 4
                        }
                    }],
                line: 268
            },
            "16": {
                loc: {
                    start: {
                        line: 292,
                        column: 2
                    },
                    end: {
                        line: 298,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 292,
                            column: 2
                        },
                        end: {
                            line: 298,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 292
            },
            "17": {
                loc: {
                    start: {
                        line: 293,
                        column: 3
                    },
                    end: {
                        line: 294,
                        column: 33
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 293,
                            column: 3
                        },
                        end: {
                            line: 293,
                            column: 40
                        }
                    }, {
                        start: {
                            line: 294,
                            column: 3
                        },
                        end: {
                            line: 294,
                            column: 33
                        }
                    }],
                line: 293
            },
            "18": {
                loc: {
                    start: {
                        line: 305,
                        column: 2
                    },
                    end: {
                        line: 307,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 305,
                            column: 2
                        },
                        end: {
                            line: 307,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 305
            },
            "19": {
                loc: {
                    start: {
                        line: 317,
                        column: 7
                    },
                    end: {
                        line: 319,
                        column: 42
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 318,
                            column: 9
                        },
                        end: {
                            line: 318,
                            column: 33
                        }
                    }, {
                        start: {
                            line: 319,
                            column: 9
                        },
                        end: {
                            line: 319,
                            column: 42
                        }
                    }],
                line: 317
            },
            "20": {
                loc: {
                    start: {
                        line: 337,
                        column: 5
                    },
                    end: {
                        line: 339,
                        column: 5
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 337,
                            column: 6
                        },
                        end: {
                            line: 337,
                            column: 30
                        }
                    }, {
                        start: {
                            line: 337,
                            column: 34
                        },
                        end: {
                            line: 337,
                            column: 58
                        }
                    }, {
                        start: {
                            line: 338,
                            column: 5
                        },
                        end: {
                            line: 338,
                            column: 15
                        }
                    }],
                line: 337
            },
            "21": {
                loc: {
                    start: {
                        line: 350,
                        column: 2
                    },
                    end: {
                        line: 367,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 350,
                            column: 2
                        },
                        end: {
                            line: 367,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 350
            },
            "22": {
                loc: {
                    start: {
                        line: 386,
                        column: 2
                    },
                    end: {
                        line: 400,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 386,
                            column: 2
                        },
                        end: {
                            line: 400,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 386
            },
            "23": {
                loc: {
                    start: {
                        line: 386,
                        column: 6
                    },
                    end: {
                        line: 386,
                        column: 42
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 386,
                            column: 6
                        },
                        end: {
                            line: 386,
                            column: 25
                        }
                    }, {
                        start: {
                            line: 386,
                            column: 29
                        },
                        end: {
                            line: 386,
                            column: 42
                        }
                    }],
                line: 386
            },
            "24": {
                loc: {
                    start: {
                        line: 389,
                        column: 6
                    },
                    end: {
                        line: 391,
                        column: 6
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 389,
                            column: 6
                        },
                        end: {
                            line: 389,
                            column: 25
                        }
                    }, {
                        start: {
                            line: 390,
                            column: 6
                        },
                        end: {
                            line: 390,
                            column: 60
                        }
                    }],
                line: 389
            },
            "25": {
                loc: {
                    start: {
                        line: 393,
                        column: 6
                    },
                    end: {
                        line: 397,
                        column: 6
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 393,
                            column: 6
                        },
                        end: {
                            line: 393,
                            column: 19
                        }
                    }, {
                        start: {
                            line: 394,
                            column: 6
                        },
                        end: {
                            line: 396,
                            column: 13
                        }
                    }],
                line: 393
            },
            "26": {
                loc: {
                    start: {
                        line: 408,
                        column: 2
                    },
                    end: {
                        line: 441,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 408,
                            column: 2
                        },
                        end: {
                            line: 441,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 408
            },
            "27": {
                loc: {
                    start: {
                        line: 412,
                        column: 21
                    },
                    end: {
                        line: 414,
                        column: 24
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 413,
                            column: 6
                        },
                        end: {
                            line: 413,
                            column: 24
                        }
                    }, {
                        start: {
                            line: 414,
                            column: 6
                        },
                        end: {
                            line: 414,
                            column: 24
                        }
                    }],
                line: 412
            },
            "28": {
                loc: {
                    start: {
                        line: 415,
                        column: 21
                    },
                    end: {
                        line: 415,
                        column: 55
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 415,
                            column: 36
                        },
                        end: {
                            line: 415,
                            column: 42
                        }
                    }, {
                        start: {
                            line: 415,
                            column: 45
                        },
                        end: {
                            line: 415,
                            column: 55
                        }
                    }],
                line: 415
            },
            "29": {
                loc: {
                    start: {
                        line: 435,
                        column: 13
                    },
                    end: {
                        line: 435,
                        column: 46
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 435,
                            column: 28
                        },
                        end: {
                            line: 435,
                            column: 38
                        }
                    }, {
                        start: {
                            line: 435,
                            column: 41
                        },
                        end: {
                            line: 435,
                            column: 46
                        }
                    }],
                line: 435
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0,
            "88": 0,
            "89": 0,
            "90": 0,
            "91": 0,
            "92": 0,
            "93": 0,
            "94": 0,
            "95": 0,
            "96": 0,
            "97": 0,
            "98": 0,
            "99": 0,
            "100": 0,
            "101": 0,
            "102": 0,
            "103": 0,
            "104": 0,
            "105": 0,
            "106": 0,
            "107": 0,
            "108": 0,
            "109": 0,
            "110": 0,
            "111": 0,
            "112": 0,
            "113": 0,
            "114": 0,
            "115": 0,
            "116": 0,
            "117": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0
        },
        b: {
            "0": [0, 0],
            "1": [0, 0],
            "2": [0, 0, 0, 0],
            "3": [0, 0],
            "4": [0, 0],
            "5": [0, 0],
            "6": [0, 0],
            "7": [0, 0],
            "8": [0, 0],
            "9": [0, 0],
            "10": [0, 0],
            "11": [0, 0],
            "12": [0, 0],
            "13": [0, 0],
            "14": [0, 0, 0],
            "15": [0, 0],
            "16": [0, 0],
            "17": [0, 0],
            "18": [0, 0],
            "19": [0, 0],
            "20": [0, 0, 0],
            "21": [0, 0],
            "22": [0, 0],
            "23": [0, 0],
            "24": [0, 0],
            "25": [0, 0],
            "26": [0, 0],
            "27": [0, 0],
            "28": [0, 0],
            "29": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "9462266b7964add98df36af5c827270dc54171d0"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_1f7x4xylj = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1f7x4xylj();
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from '@reduxjs/toolkit';
import { WebAuth } from 'auth0-js';
import classnames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { Button, Loader } from 'vio-components';
import { ROUTES } from 'vio-constants';
import { addSecondsToCurrentDate, getAuth0ClientId, getAuth0Domain, setAuth0VaporCookie, usePrevious, useReduxState, validateEmail } from 'vio-libs';
import { failedAuth0Authentication, requestAuthConnection, requestSetServerSideCookie, resetAuth0, setAuthorized } from '../../redux';
const consumerAPI = (cov_1f7x4xylj().s[0]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.consumer_api_rollout);
const useSessionCookie = (cov_1f7x4xylj().s[1]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.server_side_cookies);
const kineticGridLogo = (cov_1f7x4xylj().s[2]++, require('../../../images/svg/kinetic-grid-logo-dark.svg'));
const vaporTradeMark = (cov_1f7x4xylj().s[3]++, require('../../../images/svg/vapor-trade-mark.svg'));
const initialLoginState = (cov_1f7x4xylj().s[4]++, {
    accessToken: undefined,
    databaseLogin: false,
    email: '',
    isEmailValid: true,
    password: '',
    requestingAuthentication: false,
    showPassword: false
});
cov_1f7x4xylj().s[5]++;
const Login = () => {
    cov_1f7x4xylj().f[0]++;
    const { t } = (cov_1f7x4xylj().s[6]++, useTranslation(['Login', 'Common']));
    const dispatch = (cov_1f7x4xylj().s[7]++, useDispatch());
    const navigate = (cov_1f7x4xylj().s[8]++, useNavigate());
    const location = (cov_1f7x4xylj().s[9]++, useLocation());
    const wss = (cov_1f7x4xylj().s[10]++, window.sessionStorage);
    const webAuth = (cov_1f7x4xylj().s[11]++, new WebAuth({
        clientID: getAuth0ClientId(vaporio),
        domain: getAuth0Domain(vaporio),
        redirectUri: `${window.location.origin}/auth`,
        responseType: 'token'
    }));
    cov_1f7x4xylj().s[12]++;
    const getOAuthAccessToken = () => {
        cov_1f7x4xylj().f[1]++;
        const { hash } = (cov_1f7x4xylj().s[13]++, location);
        const hashParams = (cov_1f7x4xylj().s[14]++, createSearchParams(hash.substring(1)));
        cov_1f7x4xylj().s[15]++;
        return hashParams.get('access_token');
    };
    const [loginState, setLoginState] = (cov_1f7x4xylj().s[16]++, React.useState(Object.assign(Object.assign({}, initialLoginState), { accessToken: getOAuthAccessToken() })));
    const { authConnection, authConnectionError, requestingAuthConnection, requestingSetServerSideCookie } = (cov_1f7x4xylj().s[17]++, useReduxState('auth0'));
    const previousRequestingSetServerSideCookie = (cov_1f7x4xylj().s[18]++, usePrevious(requestingSetServerSideCookie));
    const previousRequestingAuthConnection = (cov_1f7x4xylj().s[19]++, usePrevious(requestingAuthConnection));
    const failedAuth0AuthenticationDispatch = (cov_1f7x4xylj().s[20]++, bindActionCreators(failedAuth0Authentication, dispatch));
    const requestAuthConnectionDispatch = (cov_1f7x4xylj().s[21]++, bindActionCreators(requestAuthConnection, dispatch));
    const requestSetServerSideCookieDispatch = (cov_1f7x4xylj().s[22]++, bindActionCreators(requestSetServerSideCookie, dispatch));
    const resetAuth0Dispatch = (cov_1f7x4xylj().s[23]++, bindActionCreators(resetAuth0, dispatch));
    const setAuthorizedDispatch = (cov_1f7x4xylj().s[24]++, bindActionCreators(setAuthorized, dispatch));
    cov_1f7x4xylj().s[25]++;
    const continueToLogin = () => {
        cov_1f7x4xylj().f[2]++;
        const { databaseLogin, email, password, requestingAuthentication } = (cov_1f7x4xylj().s[26]++, loginState);
        const isEmailValid = (cov_1f7x4xylj().s[27]++, validateEmail(email));
        cov_1f7x4xylj().s[28]++;
        if (authConnectionError) {
            cov_1f7x4xylj().b[0][0]++;
            cov_1f7x4xylj().s[29]++;
            resetAuth0Dispatch();
        }
        else {
            cov_1f7x4xylj().b[0][1]++;
        }
        cov_1f7x4xylj().s[30]++;
        if ((cov_1f7x4xylj().b[2][0]++, isEmailValid) && (cov_1f7x4xylj().b[2][1]++, !databaseLogin) && (cov_1f7x4xylj().b[2][2]++, !requestingAuthConnection) && (cov_1f7x4xylj().b[2][3]++, !requestingAuthentication)) {
            cov_1f7x4xylj().b[1][0]++;
            cov_1f7x4xylj().s[31]++;
            wss.setItem('userID', email);
            cov_1f7x4xylj().s[32]++;
            requestAuthConnectionDispatch(email);
        }
        else {
            cov_1f7x4xylj().b[1][1]++;
        }
        cov_1f7x4xylj().s[33]++;
        if ((cov_1f7x4xylj().b[4][0]++, databaseLogin) && (cov_1f7x4xylj().b[4][1]++, password)) {
            cov_1f7x4xylj().b[3][0]++;
            cov_1f7x4xylj().s[34]++;
            wss.setItem('userID', email);
            cov_1f7x4xylj().s[35]++;
            setLoginState(Object.assign(Object.assign({}, loginState), { requestingAuthentication: true }));
            cov_1f7x4xylj().s[36]++;
            webAuth.login({
                password,
                realm: authConnection,
                username: email
            }, (err, authResult) => {
                cov_1f7x4xylj().f[3]++;
                cov_1f7x4xylj().s[37]++;
                setLoginState(Object.assign(Object.assign({}, loginState), { requestingAuthentication: false }));
                cov_1f7x4xylj().s[38]++;
                if (err) {
                    cov_1f7x4xylj().b[5][0]++;
                    const { description } = (cov_1f7x4xylj().s[39]++, err);
                    cov_1f7x4xylj().s[40]++;
                    failedAuth0AuthenticationDispatch(description);
                }
                else {
                    cov_1f7x4xylj().b[5][1]++;
                    cov_1f7x4xylj().s[41]++;
                    onAuth0LockAuthentication(authResult);
                }
            });
            cov_1f7x4xylj().s[42]++;
            return;
        }
        else {
            cov_1f7x4xylj().b[3][1]++;
            cov_1f7x4xylj().s[43]++;
            if ((cov_1f7x4xylj().b[7][0]++, databaseLogin) && (cov_1f7x4xylj().b[7][1]++, !password)) {
                cov_1f7x4xylj().b[6][0]++;
                cov_1f7x4xylj().s[44]++;
                failedAuth0AuthenticationDispatch(t('PASSWORD_FIELD_REQUIRED'));
            }
            else {
                cov_1f7x4xylj().b[6][1]++;
            }
        }
        cov_1f7x4xylj().s[45]++;
        setLoginState(Object.assign(Object.assign({}, loginState), { isEmailValid }));
    };
    cov_1f7x4xylj().s[46]++;
    const handleEmailChange = event => {
        cov_1f7x4xylj().f[4]++;
        cov_1f7x4xylj().s[47]++;
        setLoginState(Object.assign(Object.assign({}, loginState), { email: event.target.value }));
    };
    cov_1f7x4xylj().s[48]++;
    const handleKeyDown = event => {
        cov_1f7x4xylj().f[5]++;
        cov_1f7x4xylj().s[49]++;
        if (event.key === 'Enter') {
            cov_1f7x4xylj().b[8][0]++;
            cov_1f7x4xylj().s[50]++;
            continueToLogin();
        }
        else {
            cov_1f7x4xylj().b[8][1]++;
        }
    };
    cov_1f7x4xylj().s[51]++;
    const handlePasswordChange = event => {
        cov_1f7x4xylj().f[6]++;
        cov_1f7x4xylj().s[52]++;
        setLoginState(Object.assign(Object.assign({}, loginState), { password: event.target.value }));
    };
    cov_1f7x4xylj().s[53]++;
    const onAuth0LockAuthentication = auth0Authentication => {
        cov_1f7x4xylj().f[7]++;
        cov_1f7x4xylj().s[54]++;
        if (useSessionCookie) {
            cov_1f7x4xylj().b[9][0]++;
            cov_1f7x4xylj().s[55]++;
            requestSetServerSideCookieDispatch(auth0Authentication, consumerAPI);
        }
        else {
            cov_1f7x4xylj().b[9][1]++;
            const { accessToken, expiresIn, idToken, state, tokenType } = (cov_1f7x4xylj().s[56]++, auth0Authentication);
            cov_1f7x4xylj().s[57]++;
            setAuth0VaporCookie({
                accessToken,
                expiresInDate: addSecondsToCurrentDate(expiresIn),
                idToken,
                state,
                tokenType
            });
            cov_1f7x4xylj().s[58]++;
            setAuthorizedDispatch();
            cov_1f7x4xylj().s[59]++;
            navigate(ROUTES.MAP);
        }
    };
    cov_1f7x4xylj().s[60]++;
    const resetDatabaseLogin = () => {
        cov_1f7x4xylj().f[8]++;
        cov_1f7x4xylj().s[61]++;
        resetAuth0Dispatch();
        cov_1f7x4xylj().s[62]++;
        setLoginState(Object.assign(Object.assign({}, loginState), { databaseLogin: false, password: '', showPassword: false }));
    };
    cov_1f7x4xylj().s[63]++;
    const resetState = () => {
        cov_1f7x4xylj().f[9]++;
        cov_1f7x4xylj().s[64]++;
        setLoginState(initialLoginState);
    };
    cov_1f7x4xylj().s[65]++;
    const togglePasswordVisibility = () => {
        cov_1f7x4xylj().f[10]++;
        const { showPassword } = (cov_1f7x4xylj().s[66]++, loginState);
        cov_1f7x4xylj().s[67]++;
        setLoginState(Object.assign(Object.assign({}, loginState), { showPassword: !showPassword }));
    };
    cov_1f7x4xylj().s[68]++;
    React.useEffect(() => {
        cov_1f7x4xylj().f[11]++;
        const { hash } = (cov_1f7x4xylj().s[69]++, location);
        const userID = (cov_1f7x4xylj().s[70]++, wss.getItem('userID'));
        cov_1f7x4xylj().s[71]++;
        if (hash) {
            cov_1f7x4xylj().b[10][0]++;
            cov_1f7x4xylj().s[72]++;
            webAuth.parseHash((err, authResult) => {
                var _a;
                cov_1f7x4xylj().f[12]++;
                cov_1f7x4xylj().s[73]++;
                if (err) {
                    cov_1f7x4xylj().b[11][0]++;
                    const { errorDescription } = (cov_1f7x4xylj().s[74]++, err);
                    cov_1f7x4xylj().s[75]++;
                    failedAuth0AuthenticationDispatch(errorDescription);
                }
                else {
                    cov_1f7x4xylj().b[11][1]++;
                    cov_1f7x4xylj().s[76]++;
                    if (((_a = authResult.idTokenPayload) === null || _a === void 0 ? void 0 : _a.email) !== userID) {
                        cov_1f7x4xylj().b[12][0]++;
                        cov_1f7x4xylj().s[77]++;
                        failedAuth0AuthenticationDispatch(t('USER_NOT_FOUND_IN_IDENTITY_PROVIDER'));
                        cov_1f7x4xylj().s[78]++;
                        navigate('/');
                    }
                    else {
                        cov_1f7x4xylj().b[12][1]++;
                        cov_1f7x4xylj().s[79]++;
                        onAuth0LockAuthentication(authResult);
                    }
                }
            });
        }
        else {
            cov_1f7x4xylj().b[10][1]++;
        }
        cov_1f7x4xylj().s[80]++;
        return function cleanUp() {
            cov_1f7x4xylj().f[13]++;
            cov_1f7x4xylj().s[81]++;
            resetState();
        };
    }, []);
    cov_1f7x4xylj().s[82]++;
    React.useEffect(() => {
        cov_1f7x4xylj().f[14]++;
        const { email } = (cov_1f7x4xylj().s[83]++, loginState);
        cov_1f7x4xylj().s[84]++;
        if ((cov_1f7x4xylj().b[14][0]++, authConnection) && (cov_1f7x4xylj().b[14][1]++, previousRequestingAuthConnection) && (cov_1f7x4xylj().b[14][2]++, !requestingAuthConnection)) {
            cov_1f7x4xylj().b[13][0]++;
            cov_1f7x4xylj().s[85]++;
            if (authConnection.toLowerCase() === 'username-password-authentication') {
                cov_1f7x4xylj().b[15][0]++;
                cov_1f7x4xylj().s[86]++;
                setLoginState(Object.assign(Object.assign({}, loginState), { databaseLogin: true }));
            }
            else {
                cov_1f7x4xylj().b[15][1]++;
                cov_1f7x4xylj().s[87]++;
                setLoginState(Object.assign(Object.assign({}, loginState), { requestingAuthentication: true }));
                cov_1f7x4xylj().s[88]++;
                webAuth.authorize({
                    connection: authConnection,
                    login_hint: email
                });
            }
        }
        else {
            cov_1f7x4xylj().b[13][1]++;
        }
    }, [authConnection, requestingAuthConnection]);
    cov_1f7x4xylj().s[89]++;
    React.useEffect(() => {
        cov_1f7x4xylj().f[15]++;
        cov_1f7x4xylj().s[90]++;
        if ((cov_1f7x4xylj().b[17][0]++, previousRequestingSetServerSideCookie) && (cov_1f7x4xylj().b[17][1]++, !requestingSetServerSideCookie)) {
            cov_1f7x4xylj().b[16][0]++;
            cov_1f7x4xylj().s[91]++;
            setAuthorizedDispatch();
            cov_1f7x4xylj().s[92]++;
            navigate(ROUTES.MAP);
        }
        else {
            cov_1f7x4xylj().b[16][1]++;
        }
    }, [requestingSetServerSideCookie]);
    cov_1f7x4xylj().s[93]++;
    const renderAuth0Lock = () => {
        cov_1f7x4xylj().f[16]++;
        const { accessToken, databaseLogin, requestingAuthentication } = (cov_1f7x4xylj().s[94]++, loginState);
        cov_1f7x4xylj().s[95]++;
        if (accessToken) {
            cov_1f7x4xylj().b[18][0]++;
            cov_1f7x4xylj().s[96]++;
            return React.createElement(Loader, {
                message: t('LOGIN_MESSAGE')
            });
        }
        else {
            cov_1f7x4xylj().b[18][1]++;
        }
        cov_1f7x4xylj().s[97]++;
        return React.createElement("div", {
            className: "auth0-lock"
        }, React.createElement("div", {
            className: "header"
        }, React.createElement("img", {
            src: kineticGridLogo
        }), React.createElement("span", {
            className: "title"
        }, t('LOG_IN_TO_YOUR_ACCOUNT')), React.createElement("span", null, databaseLogin ? (cov_1f7x4xylj().b[19][0]++, t('ENTER_YOUR_PASSWORD')) : (cov_1f7x4xylj().b[19][1]++, t('ENTER_YOUR_EMAIL_TO_CONTINUE')))), React.createElement("div", {
            className: "user-input"
        }, renderEmailField(), renderPasswordField(), React.createElement(Button, {
            variant: "info",
            className: "continue-btn",
            onClick: continueToLogin
        }, t('CONTINUE'))), renderErrors(), ((cov_1f7x4xylj().b[20][0]++, requestingAuthConnection) || (cov_1f7x4xylj().b[20][1]++, requestingAuthentication)) && (cov_1f7x4xylj().b[20][2]++, React.createElement(Loader, null)));
    };
    cov_1f7x4xylj().s[98]++;
    const renderEmailField = () => {
        cov_1f7x4xylj().f[17]++;
        const { databaseLogin, email, isEmailValid } = (cov_1f7x4xylj().s[99]++, loginState);
        const emailClassName = (cov_1f7x4xylj().s[100]++, classnames('email', {
            error: !isEmailValid
        }));
        cov_1f7x4xylj().s[101]++;
        if (databaseLogin) {
            cov_1f7x4xylj().b[21][0]++;
            cov_1f7x4xylj().s[102]++;
            return React.createElement("div", {
                className: emailClassName
            }, React.createElement("input", {
                disabled: true,
                type: "email",
                value: email
            }), React.createElement("button", {
                className: "edit-btn",
                onClick: resetDatabaseLogin
            }, t('EDIT')));
        }
        else {
            cov_1f7x4xylj().b[21][1]++;
        }
        cov_1f7x4xylj().s[103]++;
        return React.createElement("input", {
            autoFocus: true,
            className: emailClassName,
            onChange: handleEmailChange,
            onKeyDown: handleKeyDown,
            placeholder: t('EMAIL_ADDRESS'),
            spellCheck: false,
            type: "email",
            value: email
        });
    };
    cov_1f7x4xylj().s[104]++;
    const renderErrors = () => {
        cov_1f7x4xylj().f[18]++;
        const { isEmailValid } = (cov_1f7x4xylj().s[105]++, loginState);
        cov_1f7x4xylj().s[106]++;
        if ((cov_1f7x4xylj().b[23][0]++, authConnectionError) || (cov_1f7x4xylj().b[23][1]++, !isEmailValid)) {
            cov_1f7x4xylj().b[22][0]++;
            cov_1f7x4xylj().s[107]++;
            return React.createElement("div", {
                className: "errors"
            }, (cov_1f7x4xylj().b[24][0]++, authConnectionError) && (cov_1f7x4xylj().b[24][1]++, React.createElement("span", null, `${t('ERROR')}: ${authConnectionError}`)), (cov_1f7x4xylj().b[25][0]++, !isEmailValid) && (cov_1f7x4xylj().b[25][1]++, React.createElement("span", null, `${t('ERROR')}: ${t('USER_EMAIL_NOT_VALID')}`)));
        }
        else {
            cov_1f7x4xylj().b[22][1]++;
        }
        cov_1f7x4xylj().s[108]++;
        return null;
    };
    cov_1f7x4xylj().s[109]++;
    const renderPasswordField = () => {
        cov_1f7x4xylj().f[19]++;
        const { databaseLogin, password, showPassword } = (cov_1f7x4xylj().s[110]++, loginState);
        cov_1f7x4xylj().s[111]++;
        if (databaseLogin) {
            cov_1f7x4xylj().b[26][0]++;
            const passwordClassName = (cov_1f7x4xylj().s[112]++, classnames('password', {
                error: authConnectionError
            }));
            const iconTitle = (cov_1f7x4xylj().s[113]++, showPassword ? (cov_1f7x4xylj().b[27][0]++, t('HIDE_PASSWORD')) : (cov_1f7x4xylj().b[27][1]++, t('SHOW_PASSWORD')));
            const inputType = (cov_1f7x4xylj().s[114]++, showPassword ? (cov_1f7x4xylj().b[28][0]++, 'text') : (cov_1f7x4xylj().b[28][1]++, 'password'));
            cov_1f7x4xylj().s[115]++;
            return React.createElement("div", {
                className: passwordClassName
            }, React.createElement("input", {
                autoFocus: true,
                onChange: handlePasswordChange,
                onKeyDown: handleKeyDown,
                placeholder: t('PASSWORD'),
                spellCheck: false,
                type: inputType,
                value: password
            }), React.createElement("button", {
                className: "toggle-password-btn",
                onClick: togglePasswordVisibility,
                title: iconTitle
            }, React.createElement(FontAwesomeIcon, {
                icon: showPassword ? (cov_1f7x4xylj().b[29][0]++, faEyeSlash) : (cov_1f7x4xylj().b[29][1]++, faEye),
                transform: "shrink-1"
            })));
        }
        else {
            cov_1f7x4xylj().b[26][1]++;
        }
        cov_1f7x4xylj().s[116]++;
        return null;
    };
    cov_1f7x4xylj().s[117]++;
    return React.createElement("div", {
        id: "login"
    }, renderAuth0Lock(), React.createElement("div", {
        className: "trade-mark"
    }, React.createElement("span", null, t('POWERED_BY')), React.createElement("img", {
        className: "logo",
        src: vaporTradeMark
    })));
};
export default Login;
